module.exports = __webpack_public_path__ + "static/media/oncall.c8c63a26.png";